// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface WorkBasedLearningTypeDTO extends EntitySelectorDTO { 
	id: number;
	name: string | null;
}

const WorkBasedLearningTypeDTO = {
    className: 'WorkBasedLearningTypeDTO',
    create: (initValues?: Partial<WorkBasedLearningTypeDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			name: "",
        },
        initValues);
    },
	id: 'id',
	name: 'name',
};

export default WorkBasedLearningTypeDTO;